import { type ReactNode } from 'react';

import { type HTMLArkProps, ark } from '@ark-ui/react';

import type { Scale3 } from '../../lib/types';
import { cn } from '../../lib/utils';

type SpinnerProps = HTMLArkProps<'span'> & {
	size?: Scale3;
	loading?: boolean;
	children?: ReactNode;
};

function Spinner({ className, size = '2', loading = true, children, ...props }: SpinnerProps) {
	if (!loading) return children;

	return (
		<ark.span
			data-slot="spinner"
			data-size={size}
			className={cn('pt-spinner', className)}
			{...props}
		>
			<ark.span className="pt-spinner-leaf" />
			<ark.span className="pt-spinner-leaf" />
			<ark.span className="pt-spinner-leaf" />
			<ark.span className="pt-spinner-leaf" />
			<ark.span className="pt-spinner-leaf" />
			<ark.span className="pt-spinner-leaf" />
			<ark.span className="pt-spinner-leaf" />
			<ark.span className="pt-spinner-leaf" />
		</ark.span>
	);
}

export { Spinner, type SpinnerProps };
